/**
 * This file contains the base class for Amplitude events.
 * Specific events should extend AmplitudeEvent.
 */

export class AmplitudeEvent {
  constructor() {
    this.createTime = void 0;
    this.sendTime = void 0;
    this.eventId = void 0;
    this.eventName = void 0;
    this.category = void 0;
    this.createTime = Date.now();
    this.sendTime = null;
    this.eventId = crypto.randomUUID();
  }
  toEventProperties() {
    return {
      event_id: this.eventId,
      event_name: this.eventName,
      category: this.category,
      create_time: this.createTime,
      send_time: this.sendTime
    };
  }
  setSendTime(time) {
    this.sendTime = time;
  }
}
//# sourceMappingURL=base-events.js.map